import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'mm-confirm-edit',
    templateUrl: './confirm-edit.component.html',
    imports: [MatButton],
    host: {
        class: 'flex flex-col gap-4',
    }
})
export class ConfirmEditComponent {
  public constructor(private readonly _matDialogRef: MatDialogRef<any>) {}

  public async submit() {
    this._matDialogRef.close({
      type: 'save',
    });
  }

  public saveAsNew() {
    this._matDialogRef.close({
      type: 'save-as-new',
    });
  }

  public cancel() {
    this._matDialogRef.close();
  }
}
